import axios from "axios";
import {createURL} from "./client";

// createReferralLink получает персональную ссылку приглашения для указанного места показа.
export function createReferralLink(source) {
    return axios.post(createURL("/api/referrals/link"), {source});
}

// registerReferral закрепляет текущего игрока за реферальным токеном запуска.
export function registerReferral(token) {
    return axios.post(createURL("/api/referrals/register"), {token});
}

// getReferralNotifications получает новые уведомления о реферальных наградах.
export function getReferralNotifications() {
    return axios.get(createURL("/api/referrals/notifications"));
}
